(function($) {

    'use strict';

    var init = function() {
        if($('body').hasClass('single-product')) {
            manageWindowResize();
            manageMenu();
            manageMap();
            manageGallery();
            manageCharacteristics();
            manageComments();
            manageShare();
        }
    };

    var manageWindowResize = function() {
        var timeout;
        window.addEventListener('resize', function() {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            scrollHandler(true);
            manageMenu();
          }, 75);
        });

    };
   
    var menu;
    var menuReplacement;
    var menuPosition;
    var menuHeight;
    var buy;
    var buyPosition;
    var buyHeight;
    var manageMenu = function() {

        //menu docking
        menu = $('.main-content .menu');
        menuReplacement = $('.main-content .menu-replacement');
        console.log(menuReplacement)
        menuPosition = menu.position().top;
        menuHeight = $('.main-content .menu').height();

        //buy
        buy = $('.main-content .header .buy');
        buyPosition = buy.position().top;
        buyHeight = $(menu).height();

        $( window ).scroll(function (e) {
            scrollHandler();
        });

        $( document ).on('touchmove', function(e) {
            scrollHandler();
        });

        //Smooth scrolling to internal links
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            // e.stopPropagation();
            var target = this.hash;
            var $target = $(target);
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - menuHeight + 30,
            }, 500, 'swing', function () {
                // if(history.pushState) {
                //     history.pushState(null, null, target);
                // }
                // else {
                //     location.hash = target;
                // }
            });
        });
    };

    var scrollHandler = function(reset) {

        // $ ( '.price').text($( window ).scrollTop());
        // $ ( '.price').text(menuHeight);

        if( !reset && $( window ).scrollTop() > menuPosition ) {
            $( menu ).addClass('docked');
            $( menuReplacement ).height(menuHeight);
            // $( menu ).css('position', 'fixed');
            // $( menu ).css('top', 0);

            // if ( $( window ).scrollTop() > (menuPosition + menuHeight) )
            //     $( buy ).css('top', menuHeight);
            // else
            //     $( buy ).css('top', $( window ).scrollTop() - menuPosition);

        } else {
            $( menu ).removeClass('docked');
            $( menuReplacement ).height(0);
            // $( menu ).css('position', 'initial');
            // $( menu ).css('top', 'initial');
            // $( buy ).css('top', 'initial');
        }

        if( !reset && $( window ).scrollTop() > buyPosition) {
            $( buy ).addClass('docked');
        } else {
            $( buy ).removeClass('docked');
        }

        var $menuItemsLink = $('.menu .items .item a');
        $menuItemsLink.each( function() {
            var delta = $( window ).scrollTop() - $( $(this).attr('href') ).position().top + ( buy.css('bottom') == "0px" ? 70 : 30);
            if (delta > 0) {
                $menuItemsLink.removeClass('active')
                $(this).addClass("active");
            }

        })
    };

    var animationDuration = 500;
    var manageMap = function() {
        var a = $('.main-content .maps .map a');
        a.on('click', function (e) {
            if ( !$(e.currentTarget).parent().hasClass('active') )
                e.preventDefault();
        });


        var map = $('.main-content .maps .map');
        map.on('click', function (e) {

            if( !$(e.currentTarget).hasClass('active') ) {
                $('.main-content .maps .map_circuit img').css('opacity', 1).animate({opacity: 0}, animationDuration/2, "linear");
                $('.main-content .maps .map_region img').css('opacity', 1).animate({opacity: 0}, animationDuration/2, "linear", function() {
                    map.removeClass('active');
                    $(e.currentTarget).addClass('active');
                    $('.main-content .maps .map_region img').css('opacity', 0).animate({opacity: 1}, animationDuration/2, "linear");
                    $('.main-content .maps .map_circuit img').css('opacity', 0).animate({opacity: 1}, animationDuration/2, "linear");
                });

            }
        });
    };

    var manageGallery = function() {
        var owl = $('.owl-carousel').owlCarousel({
            autoplay: false,
            autoplayTimeout: 3000,
            loop: true,
            margin: 10,
            nav: true,
            responsive: {
                0:{
                    items:1,
                    nav: true
                },
                992:{
                    items:4,
                    nav: true
                }
            }
        });

        $('[data-fancybox]').fancybox({
            toolbar  : false,
            keyboard : false,
            arrows : true,
            // touch : false,
            smallBtn : true,
            iframe : {
                preload : false
            },
            media : {
                youtube : {
                    params : {
                        autoplay : 0
                    }
                }
            }
        });


    };

    var manageCharacteristics = function() {
        var contents = $('.main-content .characteristics .characteristic .content');
        contents.map(function() {
            var height = $(this).height();
            $(this).attr('data-height', height);
            if( !$(this).parent().hasClass('start-open')) {
                $(this).height(0);
                $(this).parent().toggleClass('open');
                $(this).css('transition-duration', (height/500).toFixed(2)+'s');
            }
        });

        var collapseButtons = $('.main-content .characteristics .characteristic .collapse-button');
        collapseButtons.on('click', function (e) {
            var content = $(e.currentTarget).parent().find('.content');
            var height = $(content).attr('data-height');
            $(e.currentTarget).parent().toggleClass('open');
            if( $(e.currentTarget).parent().hasClass('open') )
                $(content).height(height);
            else
                $(content).height(0);
        });
    };
    
    
    var manageShare = function() {
//        console.log('manageShare');
        $('.single-product .share').on('click', function(){
//            console.log('share action');
            $('.single-product .shareLinks').slideToggle();
        });
    };


    var manageComments = function() {

        var mores = $('.main-content .comments .comment .more');
        mores.map(function() {
            mores.removeClass('hide');
            var comment = $(this).parent();
            comment.find('.full').css('display', 'none');
            comment.parent().find('.truncated').css('display', 'block');
            comment.height(comment.parent().find('.truncated').height());
        });

        mores.on('click', function (e) {
            var comment = $(e.currentTarget).parent();
            var height; 
            if( comment.find('.full').css('display') == 'none') {
                comment.find('.truncated').css('display', 'none');
                comment.find('.full').css('display', 'block');
                comment.height(comment.find('.full').height());
            } else {
                comment.find('.full').css('display', 'none');
                comment.find('.truncated').css('display', 'block');
                comment.height(comment.find('.truncated').height());
            }
        });

        var addComment = $('.main-content .comments .add-comment');
        addComment.removeClass('open');
        var form = $('.main-content .comments .comments-form');
        form.css('max-height', 0);
        addComment.on('click', function (e) {
            addComment.toggleClass('open');
            form.css('max-height', addComment.hasClass('open') ? '1000px' : 0);
        });
       

        var commentsFormsSubmit = $('.main-content .comments .comments-form .form-submit input[type="submit"]');
        var requiredInputs = $('.main-content .comments .comments-form .required').parent().find('input');
        var requireds = $('.main-content .comments .comments-form .required').parent();
        commentsFormsSubmit.on('click', function (e) {
            var prevent = false;
            var rating = false;
            requiredInputs.each( function() {

                if( $(this).attr("type") == "text" && $(this).val() == '') {
                    $(this).addClass('comments-form__error');
                    prevent = true;

                } else if ( $(this).attr("name") == "email" && !isEmail($(this).val())) {
                    $(this).addClass('comments-form__error');
                    prevent = true;
                } else {
                    $(this).removeClass('comments-form__error');
                }

                if ( $(this).attr("name") == "rating" && $(this).is(':checked')) {
                   rating = true;
                }
            });

            if( !rating ) {
                $('.main-content .comments .comments-form .ratings').addClass('comments-form__error');
                prevent = true;
            }
            else {
                $('.main-content .comments .comments-form .ratings').removeClass('comments-form__error');
            }

            /*
            var $comment = $('.main-content .comments .comments-form .comment-form-comment #comment');
            if( $comment.val() == '' ) {
                $comment.addClass('comments-form__error');
                prevent = true;
            }
            else {
                $comment.removeClass('comments-form__error');
            }
            */

            if( !prevent )
                return; 
            // e.preventDefault();
            return false;
        });

    };

    function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    $(document).ready(function() {
        init();
    });

})(jQuery);